export const selectSearchedCustomer = (state) => state.customer.searchedCustomer;
export const selectCreatedCustomer = (state) => state.customer.createdCustomer;
export const selectCustomerAddresses = (state) => state.customer.searchedCustomer?.addresses;
export const selectPastOrders = (state) => state.customer.pastOrders;
export const selectActiveOrders = (state) => state.customer.activeOrders;

export const selectIsUserSearched = (state) => state.customer.isUserSearched;
export const selectSelectedAddress = (state) => state.customer.selectedAddress;
export const selectServiceType = (state) => state.customer?.service_type;
export const selectEditingAddress = (state) => state.customer.editingAddress;
export const selectIsEditMode = (state) => state.customer.isEditMode;
export const selectSelectedCompanyAddressId = (state) => state.customer.selectedCompanyAddressId;